<template>
  <div
    class="main-background filter-page-container"
    :style="{ height: pageHeight + 'px' }"
  >
    <div
      class="filter-page-back-button"
      @click="$emit('setIsChangePage', 'home')"
    >
      <chevron-left-icon class="back-button-icon" />
      <p class="back-button-text">Повернутись до каталогу</p>
    </div>
    <div class="success-info-block">
      <check-icon class="check-icon" />
      <!-- <p class="success-info-text">{{ `Ваше замовлення №${getOrderId.id} було успішно сформовано.` }}</p> -->
      <p class="success-info-text">
        Перейдіть, будь ласка, до оплати замовлення для його оформлення.
      </p>
    </div>
    <div class="bottom-filter-button-container">
      <!-- <button class="filtration-button" @click="$emit('setIsChangePage', 'home')">
                Повернутися в каталог
            </button> -->
      <button class="return-to-shop" @click="setReturnToChatBot">
        Перейти до оплати
      </button>
    </div>
  </div>
</template>

<script>
import { ChevronLeftIcon, CheckIcon } from "vue-feather-icons";
// import { GET_COME_TO_PAY } from '../helpers/requests'

export default {
  name: "is-success-page",
  components: {
    ChevronLeftIcon,
    CheckIcon,
  },
  props: {},
  data() {
    return {
      productCounter: 0,
      customerName: "",
      customerSecondName: "",
      customerPostNumber: "",
      onOrderNumber: "",
      customerCity: "",
      isWrongFormat: false,
      pageHeight: 0,
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    this.pageHeight = window.innerHeight - 150;
  },
  computed: {
    getOrderId() {
      return this.$store.getters.getOrderId;
    },
  },
  methods: {
    async setReturnToChatBot() {
      let result = this.$store.dispatch("setReturnToBot", this.getOrderId.id);
      result
        .then((value) => {
          console.log(value);
          window.Telegram.WebApp.close();
        })
        .catch((error) => alert(error.message));
    },
    setChangeCounter(value) {
      if (value === "+") {
        this.productCounter += 1;
      } else {
        this.productCounter -= 1;
      }
    },
    setCounterFinalPrice(array) {
      let price = 0;
      array.forEach((el) => {
        if (el.price) {
          price = price += el.price;
        }
      });
      return price;
    },
  },
  watch: {},
};
</script>

<style scoped>
.main-background {
  background: #fff;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
}
.filter-page-back-button {
  position: relative;
  border-bottom: 1px solid #f0f0f0;
  padding: 18px;
  cursor: pointer;
}

.back-button-icon {
  position: absolute;
}

.back-button-text {
  text-align: center;
}

.filter-page-container {
  display: flex;
  flex-direction: column;
}

.bottom-filter-button-container {
  background: #fff;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.04);
  padding: 16px;
  margin-top: auto;
}

.filtration-button {
  padding: 12px;
  width: 100%;
  border-radius: 8px;
  background: #343745;
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
}

.return-to-shop {
  padding: 12px;
  width: 100%;
  border-radius: 8px;
  background: #fff;
  color: #343745;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid #343745;
}

.success-info-block {
  border-radius: 12px;
  border: 1px solid #d2d6db;
  background: #fff;
  margin: 30px auto 0 auto;
  width: 345px;
  padding: 12px 12px 50px 12px;
  display: flex;
  flex-direction: column;
}

.check-icon {
  width: 50px;
  height: 50px;
  color: #343745;
  margin: 0 auto;
}

.success-info-text {
  color: #333;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  max-width: 300px;
  margin: 0 auto;
}
</style>
